/**
 * Created by jinbian on 26/11/2017.
 */
import axios from "axios";

export const DEVNET_SELECTED_LINK = "devnet_selected_link";
export const DEVNET_SELECTED_LINK_ORIGINAL_PAGE_URL = "devnet_selected_link_url";


export function initSocialLogin() {
    window.PlatformSDK.currentConfig = {
        socialLogin: {
            tracking: {
                origin: "devnet-portal"
            }
        },
        profileMenu: {
            attachedDomId: "dn-profile-mount",
        }
    };


    window.addEventListener('devnet.social.ui.profile.clicked', (event) => {
        let clickedMenuOption = event.detail;
        if (clickedMenuOption && clickedMenuOption.id == 'logout') {
            window.PlatformSDK.logout().then(() => {
                window.location.reload();
            });

        }
    });

    window.addEventListener('devnet.social.sdk.register.success', (eventData) => {
        window.location.reload();
    });


}


export function isPageProtected(pathname = window.location.pathname) {
    return window.LOGIN_PROTECTED_PAGES.indexOf(pathname) !== -1;
}

export function isPageProtectedByCCO(pathname = window.location.pathname) {
    // remove the last / and test
    return window.CISCOSSO_PROTECTED_PAGES.indexOf(pathname) !== -1 || window.CISCOSSO_PROTECTED_PAGES.indexOf(pathname.slice(0, -1)) !== -1;
}

export function hashCiscoPermission(accessLevel = 1) {
    const userinfo = PlatformSDK.userProfile;
    if (!userinfo) {
        return false;
    }
    return userinfo.iss == 'ciscosso';
}

export function openCISCOLoginPopup(closeCallback, autoLogin) {

    try {
        // once
        // create one time event
        if (closeCallback) {
            const callback = function (event) {
                closeCallback();
                window.removeEventListener('devnet.social.ui.login.closed', callback)
            };
            window.addEventListener('devnet.social.ui.login.closed', callback);
        }

        if (autoLogin) {
            PlatformSDK.loginWith("ciscosso");
        } else {
            PlatformSDK.openLogin("Cisco CCO login required.", [{ "id": "ciscosso", "name": "CISCO" }]);
        }

    } catch (e) {
        console.error("Error occurred ", e);
    }
}

export function trackProtectedContent(keyName, techAreas, contentName) {
    try {

        let userInfo = PlatformSDK.userProfile;

        if (!userInfo) {
            return
        }

        window.AnalyticsSDK.trackAction("protected_content:" + keyName, "download", userInfo.profileID);

        window.AnalyticsSDK.trackEsProtectContent({
            keyName,
            type: "protected_content",
            techAreas,
            contentName,
        }, userInfo);

    } catch (e) {
        console && console.error("Error occurred", e);
    }
}

export function fetchProtectContent(endPoint, bucketName, keyName) {
    return axios({
        method: 'post',
        url: endPoint,
        data: {
            bucketName,
            keyName
        },
        headers: { "Content-Type": "application/json" },
        withCredentials: true
    });
}

export function fetchFileContent(endPoint) {
    return axios({
        method: 'get',
        url: endPoint,
        headers: { "Content-Type": "application/json" },
        withCredentials: true
    });
}

function loginAndLinkCiscoAccount() {
    let goUrl = `${window.authURL}ciscosso`;
    let state = {
        url: window.location.toString(),
        client_type: "thin",
        link_profile: true,
    };
    state = encodeURIComponent(JSON.stringify(state));
    goUrl = `${goUrl}?state=${state}`;
    window.location.href = goUrl;
}
